/* NECCST interactive anatomy.
   Builds the "focus reticle" hotspots over the Series 1 line drawing and wires hover +
   focus + click, a tab rail (wide containers) and floating callout + leader (narrow).
   Hotspot data comes from the section blocks via a JSON <script class="nec-hotspots">, so
   copy/positions stay editable in the theme editor. CSS handles the container-query switch,
   the settle-in animation and prefers-reduced-motion. */
(function () {
  // Only bind hover on hover-capable pointers, and focus-reveal only during keyboard nav.
  // Without this, a touch tap fires mouseenter + focus + click in sequence and the marker
  // opens then immediately closes (hotspots "don't show" on mobile).
  var NEC_HOVER = window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var NEC_KBD = false;
  document.addEventListener('keydown', function (e) { if (e.key === 'Tab') NEC_KBD = true; }, true);
  document.addEventListener('pointerdown', function () { NEC_KBD = false; }, true);

  function build(fig) {
    var dataEl = fig.querySelector('.nec-hotspots');
    var HOT = [];
    try { HOT = JSON.parse(dataEl.textContent); } catch (e) { HOT = []; }
    if (!HOT.length) return;

    var art = fig.querySelector('.nec-art');
    var layer = fig.querySelector('.nec-layer');
    var rail = fig.querySelector('.nec-rail');
    if (!art || !layer || !rail) return;

    var eb = document.createElement('div');
    eb.className = 'nec-rail-eyebrow';
    eb.textContent = fig.getAttribute('data-eyebrow') || 'Explore';
    rail.appendChild(eb);

    var recs = [];

    HOT.forEach(function (h) {
      var accent = h.a ? ' is-accent' : '';

      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'nec-dot' + accent;
      dot.style.left = h.x + '%';
      dot.style.top = h.y + '%';
      dot.setAttribute('aria-label', h.label + (h.desc ? '. ' + h.desc : ''));
      dot.setAttribute('aria-expanded', 'false');
      dot.innerHTML = '<span class="nec-br tl"></span><span class="nec-br tr"></span><span class="nec-br bl"></span><span class="nec-br br"></span><span class="nec-hit"></span>';
      layer.appendChild(dot);

      var card = document.createElement('div');
      card.className = 'nec-card' + accent;
      card.innerHTML = '<span class="nec-card-label"></span><span class="nec-card-desc"></span>';
      card.querySelector('.nec-card-label').textContent = h.label;
      card.querySelector('.nec-card-desc').textContent = h.desc || '';
      art.appendChild(card);

      var leader = document.createElement('span');
      leader.className = 'nec-leader' + accent;
      art.appendChild(leader);

      var tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'nec-tab' + accent;
      tab.setAttribute('aria-expanded', 'false');
      tab.innerHTML = '<span class="nec-tab-label"></span><span class="nec-tab-desc"><span></span></span>';
      tab.querySelector('.nec-tab-label').textContent = h.label;
      tab.querySelector('.nec-tab-desc > span').textContent = h.desc || '';
      rail.appendChild(tab);

      var rec = { h: h, dot: dot, card: card, leader: leader, tab: tab };
      recs.push(rec);

      function open() { activate(rec); }
      function close() { deactivate(rec); }
      [dot, tab].forEach(function (elm) {
        if (NEC_HOVER) {
          elm.addEventListener('mouseenter', open);
          elm.addEventListener('mouseleave', close);
        }
        elm.addEventListener('focus', function () { if (NEC_KBD) open(); });
        elm.addEventListener('blur', function () { if (NEC_KBD) close(); });
        elm.addEventListener('click', function (e) {
          e.preventDefault();
          if (e.detail === 0) return; // ignore synthetic (keyboard/programmatic) clicks
          elm.classList.contains('is-active') ? close() : open();
        });
      });
    });

    function place(rec) {
      var W = art.clientWidth, H = art.clientHeight;
      var dx = rec.h.x / 100 * W, dy = rec.h.y / 100 * H;
      var c = rec.card, l = rec.leader;
      var cw = c.offsetWidth || 220, ch = c.offsetHeight || 80, G = 30;
      var right = rec.h.x < 52;
      var cx = right ? dx + G : dx - G - cw, cy = dy - ch / 2;
      cy = Math.max(6, Math.min(cy, H - ch - 6));
      if (cx < 6) cx = 6;
      if (cx + cw > W - 6) cx = W - cw - 6;
      c.style.left = cx + 'px';
      c.style.top = cy + 'px';
      var tx = right ? cx : cx + cw;
      var ty = Math.max(cy + 12, Math.min(dy, cy + ch - 12));
      var len = Math.hypot(tx - dx, ty - dy);
      var ang = Math.atan2(ty - dy, tx - dx) * 180 / Math.PI;
      l.style.left = dx + 'px';
      l.style.top = dy + 'px';
      l.style.width = len + 'px';
      l.style.transform = 'rotate(' + ang + 'deg)';
    }

    function activate(rec) {
      fig.classList.add('is-engaged');
      recs.forEach(function (r) { if (r !== rec) deactivate(r, true); });
      rec.dot.classList.add('is-active');
      rec.dot.setAttribute('aria-expanded', 'true');
      rec.tab.classList.add('is-active');
      rec.tab.setAttribute('aria-expanded', 'true');
      place(rec);
      rec.card.classList.add('is-shown');
      rec.leader.classList.add('is-shown');
    }

    function deactivate(rec, silent) {
      rec.dot.classList.remove('is-active');
      rec.dot.setAttribute('aria-expanded', 'false');
      rec.tab.classList.remove('is-active');
      rec.tab.setAttribute('aria-expanded', 'false');
      rec.card.classList.remove('is-shown');
      rec.leader.classList.remove('is-shown');
      if (!silent) fig.classList.remove('is-engaged');
    }

    var raf;
    window.addEventListener('resize', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var a = recs.filter(function (r) { return r.dot.classList.contains('is-active'); })[0];
        if (a) place(a);
      });
    });
  }

  document.querySelectorAll('[data-nec]').forEach(build);
})();
